import alertsTellUsWheretoLook from 'images/alerts_screenshot-crop_tell-us-where-to-look.webp';
import alertsHostNotReportingSelection from 'images/alerts_screenshot-crop_host-not-reporting-selection.webp';
import alertsSetConditionThresholds from 'images/alerts_screenshot-crop_set-condition-thresholds.webp';
import alertsSignalsLostOptions from 'images/alerts_screenshot-crop_signals-lost-options.webp';
import * as React from 'react';
export default {
  alertsTellUsWheretoLook,
  alertsHostNotReportingSelection,
  alertsSetConditionThresholds,
  alertsSignalsLostOptions,
  React
};